import * as _4 from 'lodash4';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { SectionSwapServant } from '../../servants/section_swap_servant';
import { SwapFacade } from '../../facades/swap_facade';

export class UnscheduledSectionSwapButtonController {
  private section: ISection;
  private canSwap: boolean;
  constructor(private ngSectionSwapServant: SectionSwapServant, private ngSwapFacade: SwapFacade) {}
  $onInit() {
    this.init();
  }

  init() {
    this.canSwap = this.ngSectionSwapServant.isInSwapMode();
  }

  $onChanges() {
    this.init();
  }

  swapButtonTriggered() {
    this.ngSwapFacade.saveSwapToAndRedirect(this.section);
  }
}

angular.module('capability-ng-scheduler').component('unscheduledSectionSwapButton', {
  templateUrl:
    'capability-ng-scheduler/src/swap/components/unscheduled_section_swap_button/unscheduled_section_swap_button.html',
  controller: UnscheduledSectionSwapButtonController,
  bindings: {
    section: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/components/unscheduled_section_swap_button/unscheduled_section_swap_button.ts